<template>
  <PasswordResetSteps
    :steps="steps"
    image="img/windows-pwb-graphic.png"
  />
</template>

<script>
import PasswordResetSteps from 'client/components/PasswordResetSteps.vue';

export default {
  name: 'WindowsPasswordReset',

  components: {
    PasswordResetSteps,
  },

  data() {
    return {
      steps: [
        {
          step: 1,
          text: 'Press Ctrl + Alt + Del and select "Change Password"',
        },
        {
          step: 2,
          text: 'Fill in password fields* and press "Enter"',
        },
        {
          step: 3,
          text: 'Click "OK". Your password has been updated.',
        },
      ],
    };
  },
};
</script>
